/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
           unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
           active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="/">
    </div>
    <el-submenu v-for="menu in menuList" :index="menu.label" :key="menu.id">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{ menu.label }}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chMenu in menu.children" :index="'/'+chMenu.url" :key="chMenu.id">
          <i class="iconfont" :class="chMenu.icon"></i>
          <span>{{ chMenu.label }}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>

export default {
  name: 'leftnav',
  data() {
    return {
      user: {},
      collapsed: false,
      menuList: [
        {
          "label": "基础信息管理", "url": null, "id": 1, "icon": "icon-modular", "children": [
            {"id": 101, "label": "用户信息管理", "url": "system/User", "icon": "icon-favorite"},
            {"id": 102, "label": "轮播图片管理", "url": "banner/banner", "icon": "icon-favorite"},
            {"id": 103, "label": "消息通知管理", "url": "commonMsg/commonMsg", "icon": "icon-favorite"},
          ]
        },
        {
          "label": "表白墙信息管理", "url": "", "id": 2, "icon": "icon-menu", "children": [
            {"id": 201, "label": "帖子管理", "url": "posts/posts", "icon": "icon-favorite"},
          ]
        },
        {
          "label": "跑腿信息管理", "url": "", "id": 3, "icon": "icon-dingdan1", "children": [
            {"id": 301, "label": "优惠券管理", "url": "order/coupon", "icon": "icon-favorite"},
            {"id": 302, "label": "跑腿订单管理", "url": "order/runErrands", "icon": "icon-favorite"}
          ]
        },
        {
          "label": "支付管理", "url": "", "id": 4, "icon": "icon-menu", "children": [
            {"id": 401, "label": "账单管理", "url": "order/order", "icon": "icon-favorite"},
            {"id": 402, "label": "提现申请管理", "url": "order/commissionExtract", "icon": "icon-favorite"}
          ]
        }
      ]
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    if (this.user.adminType != 'ADMIN') {
      this.menuList = [{
        "label": "表白墙信息管理", "url": "", "id": 2, "icon": "icon-menu", "children": [
          {"id": 201, "label": "帖子管理", "url": "posts/posts", "icon": "icon-favorite"},
        ]
      }]
    }
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  },
  methods: {

    toWelcome() {
      this.$router.push("/user");
    }
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue